module.exports = __webpack_public_path__ + "img/stores_personal_consultation@1x.3a4b79b.jpg";